export default __webpack_public_path__ + "static/media/rafaelazevedo.c682d438.jpeg";